import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { SiTryhackme } from "react-icons/si";

import { images } from "../../constants";
import "./Navbar.scss";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  return (
    <>
      <Helmet>
        <title>A.MOUADILI Portfolio</title>
        <meta name="description" content="A.MOUADILI Portfolio" />

        <meta property="og:title" content="A.MOUADILI Portfolio" />
      </Helmet>
      <nav className="app__navbar">
        <div className="app__navbar-logo">
          <Link to="/">
            <img src={images.logo2} alt="logo" />
          </Link>
        </div>
        <ul className="app__navbar-links">
          {[
            "home",
            "about",
            "work",
            "skills",
            "projects",
            "blogs",
            "contact",
          ].map((item) => (
            <li className="app__flex p-text" key={`link-${item}`}>
              <div />
              {item === "blogs" ? (
                <Link to="/blogs">{item}</Link>
              ) : item === "projects" ? (
                <Link to="/projects">{item}</Link>
              ) : item === "contact" ? (
                <Link to="/contact">{item}</Link>
              ) : (
                <a href={`/#${item}`}>{item}</a>
              )}
            </li>
          ))}
        </ul>

        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />

          {toggle && (
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: "easeOut" }}
            >
              <HiX onClick={() => setToggle(false)} />
              <ul>
                {[
                  "home",
                  "about",
                  "work",
                  "skills",
                  "projects",
                  "blogs",
                  "contact",
                ].map((item) => (
                  <li key={item}>
                    {item === "blogs" ? (
                      <Link to="/blogs" onClick={() => setToggle(false)}>
                        {item}
                      </Link>
                    ) : item === "projects" ? (
                      <Link to="/projects" onClick={() => setToggle(false)}>
                        {item}
                      </Link>
                    ) : item === "contact" ? (
                      <Link to="/contact" onClick={() => setToggle(false)}>
                        {item}
                      </Link>
                    ) : (
                      <a href={`/#${item}`} onClick={() => setToggle(false)}>
                        {item}
                      </a>
                    )}
                  </li>
                ))}
              </ul>

              <div className="app__navbar-menu-social">
                <div>
                  <a
                    href="https://www.linkedin.com/in/abdelmounim-mouadili-6bb946283"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin />
                  </a>
                </div>
                <div>
                  <a
                    href="https://github.com/momonaim"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaGithub />
                  </a>
                </div>
                <div>
                  <a
                    href="https://tryhackme.com/p/diliabdel"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SiTryhackme />
                  </a>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
